import * as React from 'react';

export default class TreeViewSubItems extends React.Component {
  render() {
    return (
        <ul>
            {this.props.children}
        </ul>
    );
  }
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-react-wrapper/src/treeview/treeviewsubitems.tsx